var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',[_c('h1',[_vm._v("Страница не найдена!")]),_c('i-button',{attrs:{"variant":"info","to":{name: 'Catalog'}}},[_vm._v(" Смотреть каталог ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }